import { FETCH_TICKETID_SUCCESS, FETCH_TICKETID_START } from '../actions/actiontypes'

const INIT_STATE = {
	data:{},
	completed:false,
}

export default function(state = INIT_STATE, action) {
	switch(action.type){
		case FETCH_TICKETID_START:{
			return {...state};
		}
		case FETCH_TICKETID_SUCCESS:{
			return {...state, data : action.payload};
		}
		default:
			return state;
	}
}